import React from 'react';
import { Dialog, DialogActions, DialogTitle } from '@material-ui/core';
import { Button } from '@material-ui/core';
import { useDispatch } from 'react-redux';

import { deleteImage } from '../redux/imageDbSlice';
import { deleteRelationAlbumImage } from '../redux/relationAlbumImageDbSlice';
import { deleteRelationUserImage } from '../redux/relationUserImageDbSlice';
import useCurrentUserId from '../hooks/useCurrentUserId';
import useOneImageDb from '../hooks/useOneImageDb';
import useRAIIdsByImageId from '../hooks/useRAIIdsByImageId';
import useRUIIdsByImageId from '../hooks/useRUIIdsByImageId';
import useAllLatelyImageDb from '../hooks/useAllLatelyImageDb';
import { updateLatelyImage } from '../redux/latelyImageDbSlice';
import { makeLately } from '../general';

type DeleteImageDialogProps = {
  open: boolean;
  onClose: () => void;
  imageId: string | undefined;
  updateOrder: (templateId: string) => void;
}
const DeleteImageDialog: React.FC<DeleteImageDialogProps> = ({ open, onClose, imageId, updateOrder }) => {
  const dispatch = useDispatch();
  const userId = useCurrentUserId();
  const value = useOneImageDb(imageId);
  const RUIids = useRUIIdsByImageId(imageId, value?.authorId, userId);
  const RAIids = useRAIIdsByImageId(imageId, value?.authorId, userId);
  const [latelyIds, latelyValues] = useAllLatelyImageDb(value?.authorId, userId);

  const deleteImageExe = () => {
    if (imageId) {
      dispatch(deleteImage({ id: imageId, authorId: userId }));
      RUIids.forEach(id => dispatch(deleteRelationUserImage({ id })))
      RAIids.forEach(id => dispatch(deleteRelationAlbumImage({ id })))
      latelyIds.forEach((latelyId, index) => {
        const newImageIds = makeLately(latelyValues[index].imageIds, imageId, 'delete');
        dispatch(updateLatelyImage({ id: latelyId, imageIds: newImageIds })); 
      })
      updateOrder(imageId);
    }
    onClose();
  }

  return (
    <Dialog open={open} onClose={onClose} maxWidth="xs" fullWidth>
      <DialogTitle>この画像を完全に削除します。本当に削除してよろしいですか?</DialogTitle>
      <DialogActions>
        <Button color='primary' onClick={onClose}>
          キャンセル
        </Button>
        <Button color='primary' onClick={() => deleteImageExe()}>
          OK
        </Button>
      </DialogActions>
    </Dialog>
  );
}

export default DeleteImageDialog;
